class StickyCheckout extends HTMLElement {
  connectedCallback() {
    this.footer = document.querySelector('.cart__footer')
    if (!this.footer) return

    this.observer = new IntersectionObserver((entries) => {
      this.classList.toggle('sticky-checkout--hidden', entries[0].isIntersecting)
    })

    this.observer.observe(this.footer)
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect()
  }
}

customElements.define('sticky-checkout', StickyCheckout)
